import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=5528c972&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"
import style0 from "./accordion.scss?vue&type=style&index=0&id=5528c972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5528c972",
  null
  
)

export default component.exports